import dayjs from 'dayjs';
import { MONTH_TRANSLATE, WEEK, SCHEDULE_ICON } from './instance';
import Definition from '@client/config/definition';
import { chunk, cloneDeep } from 'lodash';
import { s2hmsFullStr, getLastMonday } from '@client/helper/day';
import { distanceKM2mile } from '@client/helper/distance';
import { getDistanceInfo, getSportIconBySportType, getSportIconBySportCategoryType, getEventTagByType } from '@client/helper/sport';

import { getStringByMaxBytes, getStringByte } from '@client/helper/string';

import * as corosSportConfig from '@coros/sport-config';

const { isIndoorClimbOrBoulderingTrainingSportType } = corosSportConfig.sport.climb;

const DATE_FORMAT = 'YYYYMMDD';
export default {
  name: 'calenderMix',
  data: function () {
    const COLUMNS = [];
    WEEK.forEach((item, index) => {
      COLUMNS.push({
        title: item,
        dataIndex: `day-${index + 1}`
      });
    });
    COLUMNS.push({
      title: 'R3001',
      dataIndex: 'week-sum'
    });
    return {
      tableBorder: {
        wrapper: true,
        cell: true,
        headerCell: true,
        bodyCell: true
      },
      programsConfig: {}, // 模板
      columns: COLUMNS,
      chunkDays: [],
      weekStagesData: {},
      mapDays: {},
      days: [],
      firstDay: '',
      lastDay: ''
    };
  },

  methods: {
    getStringByte,
    getStringByMaxBytes,
    appendCalenderDays(firstDay, lastDay) {
      const today = dayjs();
      const { mapDays } = this;
      let days = [];
      firstDay = dayjs(firstDay, DATE_FORMAT);
      lastDay = dayjs(lastDay, DATE_FORMAT);
      // const firstDate = dayjs(firstDay, DATE_FORMAT);
      // const lastDate = dayjs(lastDay, DATE_FORMAT);
      const firstDate = dayjs(getLastMonday(firstDay, DATE_FORMAT), DATE_FORMAT);
      const lastDate = dayjs(getLastMonday(lastDay, DATE_FORMAT, 1), DATE_FORMAT);
      // 重新填充开始的周一和结束的周一
      //计算当前时间前的天数
      const daysCount = dayjs(lastDate).diff(firstDate, 'day');
      for (let i = 0; i < daysCount; i++) {
        const day = firstDate.add(i, 'day');
        let happenDay = day.format(DATE_FORMAT);

        const data = this.getDataForDay(happenDay, today);
        data.rowGroupId = 'group-' + firstDay + '-' + i;
        if (!mapDays[happenDay]) mapDays[happenDay] = data;
      }

      // 将mapDays 转换为days数组
      const daysSortArr = Object.keys(mapDays).sort();
      daysSortArr.forEach((happenDay) => {
        days.push(mapDays[happenDay]);
      });

      this.days = days;
      this.fullfillSportCard();
    },
    /**
     *
     * @param {*} happenDay YYYYMMDD 格式
     * @param {*} today 时间格式
     */
    getDataForDay(happenDay, today) {
      const day = dayjs(happenDay, DATE_FORMAT);
      const isBefore = day.isBefore(today, 'day');
      const isAfter = day.isAfter(today, 'day');
      const isToday = day.isSame(today, 'day');
      const type = isAfter ? 'next' : isToday ? 'current' : 'prev';
      const data = {
        happenDay,
        date: day.format('D'),
        day: day.format('d'),
        dateType: 'weekday',
        DATE: this.getCalenderDate(day),
        type,
        putable: !isBefore,
        isBefore,
        isToday,
        sports: [],
        loading: false,
        popover: false,
        limit: 999
      };
      return data;
    },
    getCalenderDate(date) {
      const TODAY = dayjs();
      let { $t } = this;
      const isToday = dayjs(date).isSame(TODAY, 'day');
      const MM = date.format('MM');
      const DD = date.format('DD');

      const TODAY_DD = TODAY.format('DD');
      const TODAY_MM = TODAY.format('MM');
      if (DD === '01') {
        if (isToday) {
          return `${$t('C1038')} ${DD}`;
        } else {
          return `${$t(MONTH_TRANSLATE[MM].label)} ${DD}`;
        }
      } else if (TODAY_DD === '01' && TODAY_MM === MM && DD === '02') {
        return `${$t(MONTH_TRANSLATE[MM].label)} ${DD}`;
      } else {
        return (isToday ? `${$t('C1038')} ` : '') + DD;
      }
    },
    // 重新初始化数据
    reinitChunkDays() {
      let { chunkDays } = this;
      chunkDays.forEach((item1) => {
        item1.forEach((item2) => {
          item2.sports = [];
        });
      });
    },
    preHandleWeekStage(weekStages) {
      let { weekStagesData } = this;
      weekStages.forEach((item) => {
        let { firstDayInWeek } = item;
        // if (!weekStagesData[firstDayInWeek])
        weekStagesData[firstDayInWeek] = item;
      });
    },
    handleScheduleData(programs) {
      programs.forEach((item) => {
        if (item.sportType === 4) {
          item.simple = false;
          item.dataType = 'training';
        }
      });
    },
    handleProgramsData(programs = []) {
      programs.forEach((item) => {
        let { createTimestamp, sportType, idInPlan, planId = '', bitmapType } = item;
        let happenDay = dayjs(createTimestamp * 1000).format(DATE_FORMAT);
        // item.happenDay = happenDay;
        item.iconConfig = getSportIconBySportType(sportType, bitmapType);
        item.cardType = 'program';
        item.dataType = 'program';
        let key = idInPlan + '&' + planId;
        this.programsConfig[key] = item;
      });
    },
    handleEntriesData(entities) {
      let exitsObj = {};
      let { programsConfig } = this;
      // 第一次循环
      let today = dayjs();
      entities.forEach((item) => {
        let { happenDay, sportData, completeRate = 0, planId = '', idInPlan, id, exerciseBarChart = [], thirdParty = false } = item;
        item.entitie = cloneDeep(item);
        item.cloneable = true;
        let key = idInPlan + '&' + planId;
        let program = programsConfig[key];
        item.program = program;
        let { name = '', sportType, dataType, simple, overview = '', bitmapType } = program;
        item.cardType = 'entities';
        item.dataType = simple ? 'training' : dataType;

        const sportIconConfig = getSportIconBySportCategoryType(sportType);
        let i18n = '';
        if (sportIconConfig) {
          i18n = sportIconConfig.label;
        } else {
          i18n = Definition.getSportI18nKeyBySportType(sportType);
        }

        item.thirdParty = thirdParty;
        const displayName = name || i18n;
        // const displayOverview = overview;
        program.name = displayName;
        // program.overview = displayName;
        item.name = displayName;
        item.overview = overview;
        item.iconConfig = sportIconConfig || getSportIconBySportType(sportType, bitmapType);

        if (sportData) {
          sportType = sportData.sportType;
        }
        item.sportType = sportType;
        // 过去
        let currentDay = dayjs(happenDay + '', DATE_FORMAT);
        let isBefore = currentDay.isBefore(today, 'day');
        let isSame = currentDay.isSame(today, 'day');
        if (isBefore) {
          if (sportData) {
            // 有运动数据
            const n = parseFloat(completeRate);
            if (n >= 0.8 && n <= 1.2) {
              item.childType = 'planReach';
            } else if (n > 1.2) {
              item.childType = 'planOver';
            } else {
              item.childType = 'planFailed';
            }
            item.compareTime = sportData.startTime;
          } else {
            // 无运动数据
            item.childType = 'planMiss';
            item.compareTime = null;
          }
        } else if (isSame) {
          // 当天
          if (sportData) {
            // 有运动
            const n = parseFloat(completeRate);
            if (n >= 0.8 && n <= 1.2) {
              item.childType = 'planReach';
            } else if (n > 1.2) {
              item.childType = 'planOver';
            } else {
              item.childType = 'planFailed';
            }
            item.compareTime = item.sportData.startTime;
          } else {
            // 无运动
            item.childType = 'planFuture';
            item.compareTime = null;
          }
        } else {
          // 将来
          item.childType = 'planFuture';
          item.compareTime = null;
        }
        item.showCopy = true;
        item.isBefore = isBefore;
        item.listItem = this.getItemList(item);
        // 重构后, 提前计算, 节省一次计算量
        let chartHeight = 0;
        exerciseBarChart.forEach((item) => {
          chartHeight += item.height;
        });
        item.chartHeight = chartHeight;
        if (!exitsObj[happenDay]) exitsObj[happenDay] = [];
        exitsObj[happenDay].push(item);
      });

      // 第二次循环, 匹配date, 数据插入进对应的日期中
      this.mixToDays(exitsObj, true);
    },
    handleCompetitionsData(data) {
      let exitsObj = {};
      data.forEach((item) => {
        let type = 'competition';
        let { happenDay } = item;
        item.cardType = type;
        item.childType = 'competition';
        item.iconConfig = getEventTagByType(2);
        //  = getScheduleAssetsFile(SCHEDULE_ICON[sportType]);
        if (!exitsObj[happenDay]) exitsObj[happenDay] = [];
        exitsObj[happenDay].push(item);
      });
      this.mixToDays(exitsObj, true);
    },

    handleFreeData(data) {
      //  即兴运动, todo
      let exitsObj = {};
      let today = dayjs();
      data.forEach((item) => {
        let { startTime, happenDay, sportType, name = '', bitmapType } = item;

        const iconConfig = getSportIconBySportCategoryType(sportType);

        let i18n = '';
        if (iconConfig) {
          i18n = iconConfig.label;
        } else {
          i18n = Definition.getSportI18nKeyBySportType(sportType);
        }

        item.name = this.$t(name) || this.$t(`${i18n}`);

        let currentDay = dayjs(happenDay + '', DATE_FORMAT);
        let isBefore = currentDay.isBefore(today, 'day');
        item.showCopy = false;
        item.cardType = 'free';
        item.childType = 'planFree';
        item.isBefore = isBefore;
        item.sportType = sportType;
        item.iconConfig = iconConfig || getSportIconBySportType(sportType, bitmapType);

        item.compareTime = startTime;
        item.listItem = this.getItemList(item);
        if (!exitsObj[happenDay]) exitsObj[happenDay] = [];
        exitsObj[happenDay].push(item);
      });
      this.mixToDays(exitsObj, true);
    },
    handleEventsData(events = []) {
      //  标签
      let exitsObj = {};
      events.forEach((item) => {
        let { happenDay, type } = item;
        item.cardType = 'label';
        item.dataType = 'label';
        item.childType = 'label';
        item.iconConfig = getEventTagByType(type);
        // getScheduleAssetsFile(SCHEDULE_ICON.events[type]);
        if (!exitsObj[happenDay]) exitsObj[happenDay] = [];
        exitsObj[happenDay].push(item);
      });
      this.mixToDays(exitsObj, true);
    },

    mixToDays(exitsObj, sortable = false) {
      let { days } = this;
      days.forEach((item) => {
        let { happenDay } = item;
        let _item = exitsObj[happenDay];
        if (_item && _item.length) {
          _item.forEach((item1) => {
            item1.copying = false;
            item.sports.push(item1);
            if (item && sortable) item.sports = this.cardSort(item);
          });
        }
      });
    },
    getItemList(item) {
      let { cardType, program, childType, sportData } = item;
      let listItem = [];
      let data = item;
      if (childType === 'planMiss' || childType === 'planFailed' || childType === 'planFuture' || childType === 'planReach') {
        data = program;
      }
      if (childType === 'planReach') {
        // console.log(222, program);
      }
      if (cardType === 'free') {
        listItem = this.getFreeItemList({}, data, cardType);
      }
      if (cardType === 'entities') {
        listItem = this.getFreeItemList(data, sportData, cardType);
      }
      return listItem;
    },
    getFreeItemList(program, sportData = {}, cardType) {
      let {
        sportType,
        duration,
        trainingLoad = 0,
        totalSets,
        targetValue,
        distance = 0,
        exercises = [],
        pitch,
        distanceDisplayUnit
      } = program;
      let {
        duration: s_duration,
        trainingLoad: s_trainingLoad = 0,
        sets: s_sets,
        distance: s_distance = 0,
        sportType: s_sportType,
        happenDay,
        distanceDisplayUnit: s_distanceDisplayUnit
      } = sportData;

      sportType = sportType || s_sportType;

      const list = [];
      if (sportType === 400) {
        list.push({
          program_value: duration > 0 ? s2hmsFullStr(duration) : undefined,
          sport_value: s_duration > 0 ? s2hmsFullStr(s_duration) : undefined //实际运动
        });
        list.push({
          program_value: trainingLoad > 0 ? `${trainingLoad} TL` : undefined,
          sport_value: s_trainingLoad > 0 ? `${s_trainingLoad} TL` : undefined //实际运动
        });
      } else if (sportType === 4 || sportType === 402) {
        list.push({
          program_value: duration > 0 ? s2hmsFullStr(duration) : undefined,
          sport_value: s_duration > 0 ? s2hmsFullStr(s_duration) : undefined
        });

        list.push({
          program_value: totalSets !== undefined ? this.$t('Y1103', { OvO: totalSets }) : undefined,
          sport_value: s_sets !== undefined ? this.$t('Y1103', { OvO: s_sets }) : undefined
        });
        list.push({
          program_value: trainingLoad > 0 ? `${trainingLoad} TL` : undefined,
          sport_value: s_trainingLoad > 0 ? `${s_trainingLoad} TL` : undefined //实际运动
        });
      }
      // 训练计划的室内攀岩、抱石
      else if (isIndoorClimbOrBoulderingTrainingSportType(sportType)) {
        /**
       *   1. 若动作均为时间，显示时间（00:00/00:00:00）
            2. 若动作均为线路，显示线路数
            3. 若动作均为自由模式，显示线路数（线路数等于动作数）
            4. 若动作目标不一致，显示线路数（n条）
              1. 目标类型为时间、自由模式时，一个动作默认为一条线路
              2. 目标类型为线路时，设置的线路数量即为线路数
              3. 课程线路数为以上之和
       */
        if (exercises.filter((item) => !item.isGroup).every((item) => item.targetType === 2)) {
          list.push({
            program_value: duration > 0 ? s2hmsFullStr(duration) : undefined,
            // 没计划的 sportType 是 800, 801，不支持
            sport_value: s_duration > 0 ? s2hmsFullStr(s_duration) : undefined
          });
        } else if (
          // 目标类型 targetType=9 是路线
          // 目标类型 targetType=1 manualEnd 自由模式
          exercises.every((item) => [1, 9].includes(item.targetType))
        ) {
          list.push({
            program_value: pitch ? `${pitch} ${this.$t(sportType === 7 ? 'H9095' : 'H9039')}` : undefined,
            // 没计划的 sportType 是 800, 801，不支持
            sport_value: sportData.pitch ? `${sportData.pitch} ${this.$t(sportType === 801 ? 'H9095' : 'H9039')}` : undefined
          });
        } else {
          // 路线相加
          // const targetValues = exercises.map((item) => {
          //   if (item.targetType === 9) return item.targetValue;
          //   if (item.targetType === 1 || item.targetType === 2) return 1;
          // });
          // const targetValueSum = targetValues.reduce((pre, cur) => {
          //   return pre + cur;
          // }, 0);
          list.push({
            program_value: pitch ? `${pitch} ${this.$t(sportType === 7 ? 'H9095' : 'H9039')}` : undefined,
            // 攀岩这里sportData没有组数
            sport_value: sportData.pitch ? `${sportData.pitch} ${this.$t(sportType === 801 ? 'H9095' : 'H9039')}` : undefined
          });
        }
      } else {
        let unitA; //= sportData.unitType === 2 ? this.unit : sportData.unitType;
        let unitB; // = program.unit === 2 ? this.unit : program.unit;
        if (sportData.unitType !== undefined) {
          unitA = sportData.unitType === 2 ? this.unit : sportData.unitType;
        } else {
          unitA = this.unit;
        }
        if (program.unit !== undefined) {
          unitB = program.unit === 2 ? this.unit : program.unit;
        } else {
          unitB = this.unit;
        }
        // console.log(`distanceDisplayUnit`, program.name, s_distanceDisplayUnit, distanceDisplayUnit);
        const sportDataValue = getDistanceInfo(s_sportType, parseFloat(s_distance) / 100, unitA, {
          distanceDisplayUnit: s_distanceDisplayUnit
        });
        const sportValue = getDistanceInfo(sportType, parseFloat(distance) / 100, unitB, { distanceDisplayUnit });

        // 时间
        if (duration > 0 || s_duration > 0) {
          list.push({
            program_value: s2hmsFullStr(duration),
            sport_value: s2hmsFullStr(s_duration) //实际运动
          });
        }
        //距离
        const data_distance = Number(sportDataValue.value) || 0;
        const program_distance = Number(sportValue.value) || 0;
        if (data_distance > 0 || program_distance > 0) {
          list.push({
            program_value: `${sportValue.value} ${sportValue.unit}`,
            sport_value: `${sportDataValue.value} ${sportDataValue.unit}`
          });
        }

        // 负荷
        if (trainingLoad > 0 || s_trainingLoad > 0) {
          list.push({
            program_value: `${trainingLoad} TL`,
            sport_value: `${s_trainingLoad} TL` //实际运动
          });
        }
      }

      if (sportType === 5 && exercises.some((item) => item.targetType === 8)) {
        list.push({
          program_value: this.$t('Y1103', { OvO: totalSets }),
          sport_value: this.$t('Y1103', { OvO: s_sets })
        });
      }

      if (cardType !== 'free') {
        // return list.filter((l) => {
        //   return l.program_value !== undefined;
        // });
        return list;
      } else {
        return list.filter((l) => {
          return l.sport_value !== undefined;
        });
      }
    },
    // 生成日历运动类型卡片
    fullfillSportCard() {
      // 将月数据分组为周数据[[1,2,3,4,5,6,7],[1,2,3,4,5,6,7]]
      let { days } = this;

      let chunkDays = chunk(days, 7);
      // 混合周阶段数据
      this.makeWeekStageData(chunkDays);
      this.chunkDays = chunkDays;
    },
    makeWeekStageData(chunkDays) {
      chunkDays.forEach((week) => {
        let _firstDayInWeek = week[0].happenDay;
        let item = {
          trainSum: {},
          showTrainSum: true,
          sumByType: [],
          stage: 0,
          firstDayInWeek: _firstDayInWeek
        };
        // this.handleWeekDataFormat(item.trainSum);
        item.dateType = 'weeksum';
        week.push(item);
      });
    },
    handleWeekData() {
      let { weekStagesData, chunkDays } = this;
      chunkDays.forEach((week) => {
        let _firstDayInWeek = week[0].happenDay;

        let item = weekStagesData[_firstDayInWeek] || {
          trainSum: {},
          sumByType: [],
          showTrainSum: true,
          stage: 0,
          firstDayInWeek: _firstDayInWeek
        };
        if (item.trainSum.actualCti === undefined) {
          item.showTrainSum = false;
        }
        this.handleWeekDataFormat(item.trainSum);

        item.dateType = 'weeksum';
        let weekStage = week[7];
        const { firstDayInWeek } = weekStage;
        item.firstDayInWeek = firstDayInWeek;
        week[7] = Object.assign(cloneDeep(weekStage), { ...item, clone: true, showActData: true });
      });
    },
    handleWeekDataFormat(trainSum) {
      let { unit } = this;
      let {
        actualDuration = 0,
        actualDistance = 0,
        actualTrainingLoad = 0,
        planDuration = 0,
        planDistance = 0,
        planTrainingLoad = 0
      } = trainSum;
      // 运动数据转换
      trainSum.act_duration = s2hmsFullStr(actualDuration);
      trainSum.plan_duration = s2hmsFullStr(planDuration);
      trainSum.act_distance = distanceKM2mile(parseInt(actualDistance) / 100000, 2, unit) + (unit === 0 ? ' km' : ' mi');
      trainSum.plan_distance = distanceKM2mile(parseInt(planDistance) / 100000, 2, unit) + (unit === 0 ? ' km' : ' mi');
      trainSum.act_trainingload = actualTrainingLoad + ' TL';
      trainSum.plan_trainingload = planTrainingLoad + ' TL';
    },
    cardSort(item) {
      let { isBefore, isToday, sports, happenDay } = item;
      let arr = [];
      const arrE = [];
      const arrST = [];
      const arrSS = [];
      const arrSP = [];
      if (isBefore) {
        //  过去的
        sports.forEach((s) => {
          if (s.cardType === 'label') {
            arrE.push(s);
          } else if (s.cardType === 'free') {
            arrST.push(s);
          } else if (s.cardType.includes('plan') && s.compareTime) {
            arrST.push(s);
          } else {
            arrSS.push(s);
          }
        });
      } else if (isToday) {
        sports.forEach((s) => {
          if (s.cardType === 'label') {
            arrE.push(s);
          } else if (s.cardType === 'free') {
            arrST.push(s);
          } else if (s.cardType.includes('plan') && s.compareTime) {
            arrST.push(s);
          } else {
            arrSS.push(s);
          }
        });
      } else {
        // 未来
        sports.forEach((s) => {
          if (s.cardType === 'label') {
            arrE.push(s);
          } else {
            arrSP.push(s);
          }
        });
      }
      arrE.sort((a, b) => {
        return a.updateTime - b.updateTime;
      });
      arrST.sort((a, b) => {
        return b.compareTime - a.compareTime;
      });
      arrSS.sort((a, b) => {
        return a.sortNoInSchedule - b.sortNoInSchedule;
      });
      arrSP.sort((a, b) => {
        return a.sortNoInSchedule - b.sortNoInSchedule;
      });
      arr = arr.concat(arrE);
      arr = arr.concat(arrST);
      arr = arr.concat(arrSS);
      arr = arr.concat(arrSP);
      return arr;
    }
  }
};
